import VueRouter from 'vue-router'
import store from './store'
import swal from 'sweetalert'
import * as types from 'store/modules/login/mutation-types'
import * as dashTypes from 'store/modules/dash/mutation-types'
import env from 'src/../env.js'

const config = require('src/../config/index')
const configLabels = require('src/../config/label')

let lazyLoad = (module) => { return resolve => require([ 'components/' + module + '/component.vue' ], resolve) }
let load = (module) => { return require('components/' + module + '/component.vue') }
let moduleConfig = (module, options = { requiresAuth: false, scrollToTop: true, routeToLaravel: false, routeKnowledge: false }) => {
  let modulePath = module
  let moduleName = module
  let moduleLoad = (options.routeToLaravel) ? 'template' : module
  return { path: modulePath, name: moduleName, component: lazyLoad(moduleLoad), meta: options }
}
let routeConfigs = [
  { path: 'home' },
  { path: 'request', options: { routeToLaravel: true } },
  { path: 'generalinfo', options: { scrollToTop: false } },
  { path: 'hres82e' },
  { path: 'hres83e' },
  { path: 'hres3be', options: { routeToLaravel: true } },
  { path: 'hres3ex', options: { routeToLaravel: true } },
  { path: 'hres3fx', options: { routeToLaravel: true } },
  { path: 'hres38x', options: { routeToLaravel: true } },
  { path: 'hres3ax', options: { routeToLaravel: true } },
  { path: 'hres3cx', options: { routeToLaravel: true } },
  { path: 'hres47x', options: { routeToLaravel: true } },
  { path: 'personaldata', options: { scrollToTop: false } },
  { path: 'hres32e' },
  { path: 'hres31x' },
  { path: 'workhistory', options: { scrollToTop: false } },
  { path: 'hres34e', options: { routeToLaravel: true } },
  { path: 'hres36e', options: { routeToLaravel: true } },
  { path: 'hres86e', options: { routeToLaravel: true } },
  { path: 'hresh1x' },
  { path: 'hresh2x', options: { routeToLaravel: true } },
  { path: 'hresh3x', options: { routeToLaravel: true } },
  { path: 'hresh4x', options: { routeToLaravel: true } },
  { path: 'hresh5x', options: { routeToLaravel: true } },
  { path: 'hresh7x', options: { routeToLaravel: true } },
  { path: 'payroll', options: { scrollToTop: false } },
  { path: 'hress2e', options: { routeToLaravel: true } },
  { path: 'hres81x' },
  { path: 'hres82x', options: { routeToLaravel: true } },
  { path: 'hres83x', options: { routeToLaravel: true } },
  { path: 'hres84x', options: { routeToLaravel: true } },
  { path: 'hres69x', options: { routeToLaravel: true } },
  { path: 'timeattend', options: { scrollToTop: false } },
  { path: 'hres62e' },
  { path: 'hres6me' },
  { path: 'hres6ae' },
  { path: 'hres6de', options: { routeToLaravel: true } },
  { path: 'hres6ke' },
  { path: 'hres95e', options: { routeToLaravel: true } },
  { path: 'hres64x', options: { routeToLaravel: true } },
  { path: 'hres65x', options: { routeToLaravel: true } },
  { path: 'hres66x', options: { routeToLaravel: true } },
  { path: 'hres67x', options: { routeToLaravel: true } },
  { path: 'hres68x', options: { routeToLaravel: true } },
  { path: 'benefits', options: { scrollToTop: false } },
  { path: 'hres71e', options: { routeToLaravel: true } },
  { path: 'hres74e', options: { routeToLaravel: true } },
  { path: 'hres77e', options: { routeToLaravel: true } },
  { path: 'hres81e', options: { routeToLaravel: true } },
  { path: 'hres49x', options: { routeToLaravel: true } },
  { path: 'hres39x', options: { routeToLaravel: true } },
  { path: 'hres44x', options: { routeToLaravel: true } },
  { path: 'training', options: { scrollToTop: false } },
  { path: 'hres6ie', options: { routeToLaravel: true } },
  { path: 'hres91e', options: { routeToLaravel: true } },
  { path: 'hres41x', options: { routeToLaravel: true } },
  { path: 'hres42x', options: { routeToLaravel: true } },
  { path: 'hresh8x', options: { routeToLaravel: true } },
  { path: 'hresh6x', options: { routeToLaravel: true } },
  { path: 'performance', options: { scrollToTop: false } },
  { path: 'hress1e' },
  { path: 'hress3e' },
  { path: 'hres11x', options: { routeToLaravel: true } },
  { path: 'hres1bx', options: { routeToLaravel: true } },
  { path: 'hres9ax', options: { routeToLaravel: true } },
  { path: 'hres46x', options: { routeToLaravel: true } },
  { path: 'hres48x', options: { routeToLaravel: true } },
  { path: 'recruit', options: { scrollToTop: false } },
  { path: 'hress4e', options: { routeToLaravel: true } },
  { path: 'hres88e' },
  { path: 'managerrequest', options: { scrollToTop: false } },
  { path: 'requestall', options: { routeKnowledge: true } },
  { path: 'hrms61e', options: { routeToLaravel: true } },
  { path: 'hrms62e' },
  { path: 'hrms6ae' },
  { path: 'hrms6de', options: { routeToLaravel: true } },
  { path: 'hrms6ke' },
  { path: 'hrms6ie', options: { routeToLaravel: true } },
  { path: 'hres93e', options: { routeToLaravel: true } },
  { path: 'hrms32e' },
  { path: 'hrms95e', options: { routeToLaravel: true } },
  { path: 'hrms17e' },
  { path: 'hrms18e' },
  { path: 'hrms27u' },
  { path: 'hrms14x' },
  { path: 'managerapprove', options: { scrollToTop: false } },
  { path: 'hres7de' },
  { path: 'hres33u' },
  { path: 'hres35u' },
  { path: 'hres37u' },
  { path: 'hres3cu' },
  { path: 'hres63u' },
  { path: 'hres6nu' },
  { path: 'hres6bu' },
  { path: 'hres6eu' },
  { path: 'hres6lu' },
  { path: 'hres96u' },
  { path: 'hres72u' },
  { path: 'hres75u' },
  { path: 'hres78u' },
  { path: 'hres85u' },
  { path: 'hres87u' },
  { path: 'hress3u' },
  { path: 'hres89u' },
  { path: 'hress5u' },
  { path: 'hres6ju' },
  { path: 'hres92u' },
  { path: 'hres94u' },
  { path: 'internalcommunication', options: { scrollToTop: false } },
  { path: 'hrms75e' },
  { path: 'hrms12x' },
  { path: 'hrms13x' },
  { path: 'hrms19x' },
  { path: 'hrms76x' },
  { path: 'performanceevaluation', options: { scrollToTop: false } },
  { path: 'hrms15e' },
  { path: 'hrms31e' },
  { path: 'hrms73e' },
  { path: 'hrms74e' },
  { path: 'hrms16x' },
  { path: 'hres4ax' },
  { path: 'hrms41e' },
  { path: 'hres7fe' },
  { path: 'hres8ax' },
  { path: 'hres6oe' },
  { path: 'hres80x' },
  { path: 'hrms1ax' },
  { path: 'hrms55x' },
  { path: 'profileimg' },
  { path: 'hrese1e' },
  { path: 'hrese2e' },
  { path: 'hrese3e' },
  { path: 'stdapplinf', options: { routeKnowledge: true } },
  { path: 'stdreq', options: { routeKnowledge: true } },
  { path: 'demo', options: { routeKnowledge: true } }
]

let childrenRoutes = []
for (let routeConfig of routeConfigs) {
  if (typeof routeConfig.options !== 'undefined') {
    if (typeof routeConfig.options.routeKnowledge !== 'undefined') {
      if (process.env.NODE_ENV !== 'production' && routeConfig.options.routeKnowledge) {
        childrenRoutes.push(moduleConfig(routeConfig.path, routeConfig.options))
      }
    } else {
      childrenRoutes.push(moduleConfig(routeConfig.path, routeConfig.options))
    }
  } else {
    childrenRoutes.push(moduleConfig(routeConfig.path, routeConfig.options))
  }
}
const routes = [
  {
    path: '/',
    redirect: { name: 'home' }
  }, {
    path: '/autologin/:runno?',
    name: 'autologin',
    component: lazyLoad('autologin')
  }, {
    path: '/login/:codapp?',
    name: 'login',
    component: lazyLoad('login')
  }, {
    path: '/clearcache',
    name: 'clearcache',
    component: lazyLoad('clearcache')
  }, {
    path: '/removeimg/:folder',
    name: 'removeimg',
    component: lazyLoad('removeimg')
  }, {
    path: '/votefriend',
    name: 'votefriend',
    component: lazyLoad('votefriend')
  }, {
    path: '/',
    name: 'dash',
    component: load('dash'),
    meta: { requiresAuth: true },
    children: childrenRoutes
  // }, {
  //   path: '/styleGuide',
  //   name: 'styleGuide',
  //   component: lazyLoad('styleGuide')
  }, {
    // not found handler
    path: '*',
    name: '404',
    component: lazyLoad('404')
  }
]

let router = new VueRouter({
  base: config.build.assetsPublicPath,
  routes: routes,
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      const position = {}
      if (to.hash) {
        position.selector = to.hash
      }
      if (to.matched.some(record => record.meta.scrollToTop)) {
        position.x = 0
        position.y = 0
      }
      return position
    }
  }
})

router.beforeEach((to, from, next) => {
  if (store.getters[types.GET_CURRENT_USER] !== JSON.parse(window.localStorage.getItem(env.site + '_currentUser'))) {
    store.commit(types.SET_CURRENT_USER, JSON.parse(window.localStorage.getItem(env.site + '_currentUser')))
  }
  if (window.localStorage.getItem(env.site + '_baseURL') === null) {
    var location = window.location
    // var baseURL = (process.env.NODE_ENV !== 'development') ? location.protocol + '//' + location.host + '/' : config.build.defaultBaseURL
    var baseURL = (process.env.NODE_ENV !== 'development') ? location.origin + '/' : config.build.defaultBaseURL
    window.localStorage.setItem(env.site + '_baseURL', baseURL)
  }

  let authStatus = JSON.parse(window.localStorage.getItem(env.site + '_authStatus'))
  if (authStatus !== null) {
    if (authStatus.status) {
      let oldDateObj = new Date(authStatus.timestamp).getTime()
      let minuteDuration = config.build.sessionTimeout
      let expiration = new Date(oldDateObj + minuteDuration * 60000)
      if (new Date().getTime() > expiration.getTime()) {
        authStatus = { status: false }
        let lang = (window.localStorage.getItem(env.site + '_lang')) ? window.localStorage.getItem(env.site + '_lang') : configLabels.defaultLang
        if (new Date().getTime() - expiration.getTime() < 3) {
          swal({
            title: 'TIMEOUT',
            text: configLabels.loginMessageError[lang].TIMEOUT
          })
        }
        store.commit(types.SET_LOGOUT, {})
      } else {
        authStatus = { status: true, timestamp: new Date().getTime() }
        window.localStorage.setItem(env.site + '_authStatus', JSON.stringify(authStatus))
        store.commit(types.SET_AUTH_STATUS, authStatus)
      }
    }
  } else {
    authStatus = { status: false }
    store.dispatch(types.POST_LOGOUT)
  }

  store.commit(dashTypes.SET_CONTROLSIDEBAR_DISP_FALSE, false)
  if (to.name === 'autologin' || to.name === 'styleGuide' || to.name === 'clearcache') {
    next()
  } else {
    if (to.matched.some(record => record.meta.requiresAuth) && !authStatus.status) {
      next({ name: 'login' })
    } else {
      if (to.matched.some(record => record.meta.routeToLaravel)) {
        window.location = window.localStorage.getItem(env.site + '_baseURL') + window.localStorage.getItem(env.site + '_lang') + to.fullPath
      } else {
        if (to.name === 'login' && authStatus.status) {
          // next({ name: 'home' })
          store.dispatch(types.POST_AUTH_VUE_MIDDLEWARE, { codapp: 'home', next: next })
        } else {
          if (to.name === 'login' && !authStatus.status) {
            next()
          } else {
            if (to.matched.some(record => record.meta.routeKnowledge)) {
              next()
            } else {
              if (to.name === 'home') {
                // next()
                store.dispatch(types.POST_AUTH_VUE_MIDDLEWARE, { codapp: to.name, next: next })
              } else {
                let location = router.match(to.name)
                if (location.name !== '404') {
                  store.dispatch(types.POST_AUTH_VUE_MIDDLEWARE, { codapp: to.name, next: next })
                } else {
                  next()
                }
              }
            }
          }
        }
      }
    }
  }
})

export { router }



// WEBPACK FOOTER //
// ./src/router.js